import * as ActionTypes from './actions';
import { CHANGE_LANGUAGE } from '../languages/actions';
import { FRANCHISOR_SETTINGS_UPDATE_SUCCESS } from '../dashboard/settings/franchisor/actions';
import { i18n } from '../common/services/globalize';

const lookupsInitialState = {
	userPermissions: [],
	rolePermissions: [],
	discountTypes: [],
	documentCategories: [],
	titleTypes: [],
	genderTypes: [],
	trialLessonTypes: [],
	allLessonTypes: [],
	paymentTypes: [],
	paymentStatusTypes: [],
	messageTemplateTypes: [],
	individualConsultationTypes: [],
	languages: [],
	paymentMethods: [],
	referralSourceTypes: [],
	waitingListStatusType: [],
	paymentHistoryDocumentTypes: [],
	formStatusTypes: [],
	timetableViewTypes: [],
	workshopSessionTypes: [],
	bookingTypes: [],
	fromAddressTypes: [],
	schoolYears: [],
	years: [],
	months: []
};

const localCancellationReasonTypes = (cancellationReasonTypes) => cancellationReasonTypes.map(item => {
	return { id: item.id, name: i18n.t(`CancellationReasonType_${item.name}`) }
});

export const lookups = (state = lookupsInitialState, action) => {
	switch (action.type) {
		case ActionTypes.LOOKUPS_SUCCESS:
			return { ...action.payload, cancellationReasonTypes: localCancellationReasonTypes(action.payload.cancellationReasonTypes) };
		default:
			return state;
	}
};

const franchisorInitialState = {
	initializing: true,
	id: '',
	systemName: '',
	subdirectory: '',
	enableGoogleAnalytics: false,
	offerIndividualConsultations: false,
	offerWorkshops: false,
	metaTags: {}
};

export const franchisor = (state = franchisorInitialState, action) => {

	switch (action.type) {
		case ActionTypes.FRANCHISOR_SUCCESS:
			//if (action.payload && action.payload.timeZone) {
			//	// use owner's time zone instead of the local time zone for all dates
			//	globalize.setCurrentTimeZone(false, action.payload.timeZone);
			//}
			const franchisor = action.payload;

			return { ...state, ...franchisor, initializing: false };
		case FRANCHISOR_SETTINGS_UPDATE_SUCCESS:
			const updatedFranchisorSettings = action.response.entities.franchisorSettings[action.response.result];
			return { ...state, ...updatedFranchisorSettings };
		case CHANGE_LANGUAGE: //TODO: i18n not init with new language yet
			document.title = i18n.t('Admin_Document_Title', { systemName: state.systemName });
			return state;
		default:
			return state;
	}
};